import React from 'react'
import { Swiper, Pagination, Autoplay } from 'swiper/js/swiper.esm';
import ReactIdSwiperCustom from 'react-id-swiper/lib/ReactIdSwiper.custom';
import 'swiper/css/swiper.css';
import styles from './swiper-carousel.module.css'
import { useViewport } from '../utils';

const SwiperCarousel = ({ children, ...props }) => {
  const { isMobile } = useViewport()

  const params = {
    Swiper,
    modules: [ Pagination, Autoplay ],
    freeMode: true,
    slidesPerView: 'auto',
    loop: isMobile ? true : false,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      bulletClass: 'bullet',
      bulletActiveClass: 'active',
      renderBullet: (index, className) => {
        return `<span class="${className}"><span></span></span>`
      }
    },
  }

  const swiperOptions = {
    ...params,
    ...props
  }

  return (
    <div className={styles['swiper-carousel']}>
      <ReactIdSwiperCustom {...swiperOptions}>
        { children }
      </ReactIdSwiperCustom>
    </div>
  )
}

export { SwiperCarousel }
